export const DEFAULT_BUDGET_AMOUNT = 0;
export const MAX_DIMENSIONS_NUM = 5;
export const BUDGET_CHART_HEIGHT = "40vh";
